module.exports = __webpack_public_path__ + "img/ck-mutil-bg.5bbd8916.png";